module.exports = __webpack_public_path__ + "img/juno-small-light.4ae6d7f9.svg";